'use strict';

angular.module('ClinicApp').controller('ModalGenericOk', function($scope, $modalInstance) {
  $scope.ok = function() {
    $modalInstance.dismiss();
  };
});
